export type FieldType = "text" | "tel" | "email" | "number" | "date" | "time" | "textarea" | "select" | "checkbox";

export type FieldConfig = {
  key: string;
  type: FieldType;
  label: string;
  placeholder?: string;
  required: boolean;
  enabled: boolean;
  options?: string[];
  builtin: boolean;
};

// Cannot be disabled
export const CORE_FIELD_KEYS = new Set([
  "contact_first_name", "contact_last_name", "contact_email", "event_date",
]);

// Required toggle locked (always required) — uniquement les champs identité/date
export const ALWAYS_REQUIRED_KEYS = new Set([
  "contact_first_name", "contact_last_name", "contact_email", "event_date",
]);

export const DEFAULT_FORM_FIELDS: FieldConfig[] = [
  { key: "contact_first_name", type: "text",     label: "Prénom",               required: true,  enabled: true, builtin: true },
  { key: "contact_last_name",  type: "text",     label: "Nom",                  required: true,  enabled: true, builtin: true },
  { key: "contact_email",      type: "email",    label: "Email",                required: true,  enabled: true, builtin: true },
  { key: "contact_phone",      type: "tel",      label: "Téléphone",            required: false, enabled: true, builtin: true },
  { key: "event_type",         type: "select",   label: "Type de prestation",   required: true,  enabled: true, builtin: true },
  { key: "event_date",         type: "date",     label: "Date",                 required: true,  enabled: true, builtin: true },
  { key: "event_time",         type: "time",     label: "Heure",                required: false, enabled: true, builtin: true },
  { key: "venue_name",         type: "text",     label: "Lieu",                 required: false, enabled: true, builtin: true },
  { key: "city",               type: "text",     label: "Ville",                required: false, enabled: true, builtin: true },
  { key: "guest_count",        type: "number",   label: "Surface estimée (m²)", required: false, enabled: true, builtin: true },
  { key: "budget",             type: "number",   label: "Budget indicatif (€)", required: false, enabled: true, builtin: true },
  { key: "message",            type: "textarea", label: "Message",              required: false, enabled: true, builtin: true },
];

export function mergeWithDefaults(saved: FieldConfig[] | null | undefined): FieldConfig[] {
  if (!saved || saved.length === 0) return [...DEFAULT_FORM_FIELDS];
  const savedKeys = new Set(saved.map((f) => f.key));
  const result = [...saved];
  for (const def of DEFAULT_FORM_FIELDS) {
    if (def.builtin && !savedKeys.has(def.key)) result.push(def);
  }
  return result;
}
